import React, { useContext } from 'react';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { Play } from '@styled-icons/boxicons-regular/Play';

import TimerContext from '~/context/timerContext';

import { Button } from './styles';

const Start = () => {
  const timerContext = useContext(TimerContext);
  const { setTimerRunning, timerRunning } = timerContext;

  const handleStart = () => {
    setTimerRunning(true);
    trackCustomEvent({
      category: 'Pomodoro',
      action: 'Play',
    });
  };

  return (
    <Button
      type="button"
      className={`${timerRunning ? 'active-animation' : ''}`}
      onClick={handleStart}
    >
      <Play />
    </Button>
  );
};

export default Start;
